(ns manage.content-variant-ocp.db.lookup
  (:require [manage.content-variant-ocp.db.core :refer [entity-name ui-messages ->external-field-formats]]
            [re-frame.core :as rf]))

(rf/reg-event-fx :form.content-variant/update-field-formats
  (fn [{:keys [db]} [_ next-tab]]
    (let [feed-id (get-in db [:resource.adset/one :value :feedId])
          {:keys [settings]} (get-in db [:form.feed-lookup :value])
          field-formats (->external-field-formats settings)]
      {:fx [[:dispatch [:loader/open]]
            [:async-flow {:id :form.content-variant/update-field-formats-flow
                          :first-dispatch [:resource.feed-importers/update-field-formats feed-id field-formats]
                          :rules [{:when :seen?
                                   :events :resource.feed-importers/update-field-formats-success
                                   :halt? false
                                   :dispatch [:form.content-variant/update-field-formats-success next-tab]}
                                  {:when :seen?
                                   :events :resource.feed-importers/get-content-feed-success
                                   :halt? true
                                   :dispatch [:form.content-variant/get-content-feed-success]}
                                  {:when :seen?
                                   :events :resource.feed-importers/update-field-formats-failure
                                   :halt? true
                                   :dispatch [:form.content-variant/update-field-formats-failure]}]}]]})))

(rf/reg-event-fx :form.content-variant/update-field-formats-success
  (fn [{:keys [db]} [_ next-tab]]
    (let [next-tab (next-tab)
          feed-id (get-in db [:resource.adset/one :value :feedId])]
      {:fx [[:dispatch [:loader/close]]
            [:dispatch [:response-handler/handle-response
                        {:entity-name entity-name
                         :type :success
                         :message (get-in ui-messages [:edit :success])}]]
            [:dispatch [:resource.feed-importers/get-content-feed feed-id]]
            (when (nil? next-tab) [:dispatch [:ocp/close]])]})))

(rf/reg-event-fx :form.content-variant/update-field-formats-failure
  (fn [_ [event [_ response]]]
    {:fx [[:dispatch [:loader/close]]
          [:dispatch [:response-handler/handle-response
                      {:entity-name entity-name
                       :type :error
                       :event event
                       :message (get-in ui-messages [:edit :failure])
                       :response response}]]]}))

(rf/reg-sub :form.content-variant/lookup-fields
  :<- [:table.content-variants/columns-by-class "targeting-key"]
  (fn [field-classes]
    {:state :success
     :value (map :name field-classes)}))
